import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { CustomerOfferTypesDataGrid } from "src/components/views/erp/sales/masterData/customerOfferTypes/CustomerOfferTypesDataGrid.tsx";

export const Route = createFileRoute("/_authenticated/_shell/sales/customerOfferTypes")({
	staticData: { title: i18n.t("customer_offer_types"), legacyViewKey: "customerOfferTypesPage" },
	component: RouteComponent,
});

function RouteComponent() {
	return <CustomerOfferTypesDataGrid />;
}
